import { useState, useEffect } from "react";

// ─── USE IN VIEW ──────────────────────────────────────────────────────────────
// Fires once when the referenced element enters the viewport.
// Used for scroll-triggered animations (stat counters, fade-ups, etc.)
//
// Usage:
//   const ref = useRef(null);
//   const isVisible = useInView(ref);
//   <div ref={ref}>{isVisible && <Counter />}</div>

export function useInView(ref, threshold = 0.15) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          // Once visible, stop observing — animation only fires once
          observer.disconnect();
        }
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, threshold]);

  return visible;
}
